import { projectRejectedKey } from 'root/src/shared/constants/keys'

import { REJECT_PROJECT } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'

import { AUDIT_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default {
	[REJECT_PROJECT]: {
		endpointId: AUDIT_PROJECT,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectRejectedKey],
		],
		label: 'Reject  (admin)',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectRejectedKey,
			},
		],
	},
}
